/// <amd-module name="Wit/LinkedWorkItemsDropdown/Util/Data" />
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IListBoxItem } from "VSSUI/ListBox";
import { routeUrl } from "VSS/Platform/Location";
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";

export const WorkItemFormat = "{0} {1}: {2}";

export type IWorkItemEntry = IListBoxItem<WorkItem>;

export function getWorkItemFormUrl(pageContext: IVssPageContext, workItem: WorkItem): string {
    const routeValues: { [key: string]: string } = {};
    routeValues["project"] = workItem.fields[CoreFieldRefNames.TeamProject];
    routeValues["id"] = workItem.id.toString();

    return routeUrl(pageContext, "ms.vss-work-web.work-items-form-route", routeValues);
}

export function workItemToListBoxItem(pageContext: IVssPageContext, workItem: WorkItem): IWorkItemEntry {
    const workItemUrl = getWorkItemFormUrl(pageContext, workItem);

    return {
        data: workItem,
        id: workItem.id.toString(),
        href: workItemUrl,
        text: format(WorkItemFormat, workItem.fields[CoreFieldRefNames.WorkItemType], workItem.id, workItem.fields[CoreFieldRefNames.Title])
    };
}
